module.exports = __webpack_public_path__ + "0a8e061cad48e89ae10a26d89ef274f7.pdf";